import { API_URL } from './api';

/**
 * Opens an SSE (Server-Sent Events) connection to the backend.
 *
 * WHY NOT native EventSource with Authorization header?
 * Native EventSource doesn't support custom headers.
 * We pass the JWT as ?token=... which the backend accepts.
 *
 * @param token - JWT Bearer token for the admin session
 * @returns The connected EventSource instance
 */
export function connectSSE(token: string): EventSource {
    const url = `${API_URL}/notifications/subscribe?token=${encodeURIComponent(token)}`;
    console.log('[SSE] Connecting to:', url.replace(/token=.*/, 'token=***'));
    const es = new EventSource(url);
    return es;
}

export function disconnectSSE(es: EventSource | null): void {
    if (es) {
        es.close();
    }
}
